<template>
  <div class="progress-drawer" :class="{ minimized: isMinimized }">
    <div class="container progress-content">
      <div class="content-wrap">
        <div class="message-text">
          <slot name="message" />
        </div>
      </div>

      <div class="button-wrap">
        <MicButton
          class="next-btn"
          :has-arrow="!buttonIcon && !isLastQuestion"
          :icon-only-mobile="false"
          :mobile-button-icon="buttonIcon"
          @click="next"
        >
          {{ checkButtonText }}
          <img
            v-if="!isMobile && buttonIcon && !isLastQuestion && showButtonIcon"
            :src="require(`@mic/frontend/assets/icons/${buttonIcon}`)"
            alt="button icon"
            class="next-btn__icon"
          >
        </MicButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MicButton from '@mic/frontend/buttons/MicButton'

export default {
  name: 'ProgressDrawer',

  components: {
    MicButton
  },

  props: {
    isMinimized: {
      type: Boolean,
      required: true
    },
    buttonIcon: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters(['getQuestions', 'isMobile']),

    questions () {
      return this.getQuestions
    },
    currentQuestionIndex () {
      return this.questions.findIndex(q => q.slug === this.$route.params.slug)
    },
    isLastQuestion () {
      return this.currentQuestionIndex === this.questions.length - 1
    },
    buttonMessage () {
      if (!this.questions[this.currentQuestionIndex].drawer) return false
      if (!this.questions[this.currentQuestionIndex].drawer.buttonMessage) return false
      return this.questions[this.currentQuestionIndex].drawer.buttonMessage
    },
    checkButtonText () {
      return this.isLastQuestion ? 'All done' : this.buttonMessage || 'Next'
    },
    showButtonIcon () {
      if (!this.questions[this.currentQuestionIndex].drawer) return false
      if (!this.questions[this.currentQuestionIndex].drawer.buttonIcon) return false
      return this.questions[this.currentQuestionIndex].drawer.buttonIcon
    }
  },

  methods: {
    next () {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss">
.progress-drawer {
  .next-btn {
    height: 42px;
    width: 126px;
    min-width: 128px;
    border-radius: 5px;
    background-color: $button-bg;
    line-height: 18px;
    font-size: 14px;
    padding: 0 10px;
    transition: -webkit-transform 0.2s ease-out;

     @media (min-width: 421px) {
      font-size: 16px;
      line-height: 24px;
      height: 52px;
      width: 128px;
    }

    &:hover {
      transform: translate3d(0, -4px, 0);
      box-shadow: none;
      top: 0;
    }
  }
}
</style>

<style scoped lang="scss">
.progress-drawer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  min-height: $progress-drawer-height-desktop;
  height: 0;
  z-index: 200;
  display: flex;
  flex-direction: column;
  transition: 0.5s transform;
  background-color: $white;
  border-radius: $border-radius-large $border-radius-large 0 0;
  box-shadow: $progress-shadow;

  @media (min-width: 421px) and (max-width: $screen-md) {
    min-height: 160px;
  }

  @media (max-width: 420px) {
    min-height: $progress-drawer-height-mobile;
  }

  &.minimized {
    transform: translateY(144px);

    @media (min-width: 421px) and (max-width: $screen-md) {
      transform: translateY(160px);
    }
  }
}

.message-text {
  .message {
    @media (max-width: $screen-lg) {
      font-size: 20px;
      line-height: 24px;
      padding-right: $spacing-8;
    }

    @media (max-width: $screen-md) {
      font-family: $font-family-bold;
      font-size: $progress-drawer-message-font-size;
      line-height: 17px;
      padding-right: $spacing-8;
    }
  }
}

.progress-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  @media (min-width: $screen-md) {
    align-items: center;
    flex-direction: row;
  }
}

.icon-wrap {
  position: relative;
  width: $progress-drawer-icon-width;
  min-width: $progress-drawer-icon-width;
  height: $drawer-icon-max-size;
  transition: all 0.75s;

  @media (max-width: $screen-md) {
    display: none;
  }

  .minimized & {
    opacity: 0;
    transition: all 0.5s;
    transform: translateY(50px);
  }
}

.content-wrap {
  text-align: left;
  padding: $progress-drawer-message-padding;

  @media (min-width: $screen-md) {
    margin-right: 105px;
  }

  @media (max-width: $screen-md) {
    padding: 0;
  }

  .minimized & {
    opacity: 0;
    transition: all 0.5s;
    transform: translateY(50px);
  }
}

.button-wrap {
  transition: all 0.75s 0.4s;
  margin-left: auto;

  @media (min-width: $screen-md) {
    margin-left: unset;
  }

  .minimized & {
    display: none;
  }
}

.next-btn {
  &__icon {
    margin-left: $spacing-8;
  }
}
</style>
